import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'; 
import { LoginType } from '../types/auth';

export type AuthState = {
  email: string;
  namaToko: string;
  lokasiToko: string;
  password: string;
  confPassword: string;
};



const initialState: AuthState = {
  email: '',
  namaToko: '',
  lokasiToko: '',
  password: '',
  confPassword: '',
};



export const auth = createSlice({
    name:'auth',
    initialState,
    reducers:{
        signUp: (state, action: PayloadAction<AuthState>) => {
      // You can perform any synchronous logic with the form data here
      // For example, you can update the state with the form data.
    },
    signIn: (state, action: PayloadAction<LoginType>) => {
      // Logic to handle signing in with loginState data
      // For example, you can validate the login credentials and update the state accordingly.
    },
    } ,
    
});

export const {signUp,signIn} = auth.actions
export default auth.reducer